import React from 'react'
import { store } from 'src/_helpers'
export const SiteName = () => {
  let appconfig = store.getState().appconfg
  return (
    <b>{appconfig.site_title}</b>
  )
}

